// extracted by mini-css-extract-plugin
module.exports = {"infections-chart":"_1iEHKem","infectionsChart":"_1iEHKem","key":"_2a0L6Wo","entry":"qUD2mhc","text":"_1Gzz-e5","tt":"w3nLDH_"};